<template>
  <div class="GeneralSales">
    <div class="headerGeneralSales">
      <div style="display: flex; gap: 10px">
        <b-button class="BtnRegister" @click="handleModals('venda')">
          <b-icon-plus
            scale="1.5"
            style="
              width: 30px;
              background: #006458;
              height: 30px;
              color: white;
              border-radius: 3px;
            "
          ></b-icon-plus>
          <span style="width: 170px">Nova Venda Completa</span>
        </b-button>
        <b-button
          class="BtnRegister"
          v-if="salesSelecteds.length"
          @click.stop="enviarEmLote"
        >
          <b-icon-arrow-right
            scale="1.0"
            style="
              width: 30px;
              background: #006458;
              height: 30px;
              color: white;
              border-radius: 3px;
            "
          ></b-icon-arrow-right>
          <span style="width: 170px">Envio em lote</span>
        </b-button>
      </div>
      <div class="searchContainer">
        <div class="searchInput">
          <b-form-select
            class="searchFilter"
            :style="type === 'situacaoReceita' && 'border-radius: 3px 0 0 3px;'"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="type"
            :options="filterCombobox"
          ></b-form-select>

          <b-form-select
            v-if="type === 'situacaoReceita'"
            class="searchFilter"
            style="border-radius: 0 3px 3px 0"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="prescriptionSituation"
            :options="prescriptionSituationOpts"
            @change="filterSale(page, false, true)"
          ></b-form-select>

          <div v-else>
            <b-input
              class="inputSearch"
              placeholder="Pesquisar por..."
              v-model="textPesquisa"
              @keyup.enter="filterSale(page)"
            ></b-input>
          </div>
        </div>
        <div class="lineSearch">
          <b-form-select
            class="searchFilter"
            style="border-radius: 0 3px 3px 0"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="limitOption"
            :options="limitOptions"
            @change="filterSale(page, false, true)"
          ></b-form-select>

          <div class="summaryMonth">
            Resumo: &nbsp;
            <strong>{{
              selectTextDate === "Personalizado" ? "" : `(${selectTextDate})`
            }}</strong>
          </div>
          <div class="pagMonth"></div>
          <div
            class="searchInput"
            style="
              padding: 0px !important;
              display: flex;
              justify-content: space-between;
            "
            v-if="selectTextDate === 'Personalizado'"
          >
            <button class="btnPeriod" size="sm">Período</button>
            <div class="dateInput">
              <input
                type="date"
                id="date"
                v-model="startDate"
                style="
                  padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                  cursor: pointer;
                  border-left: none;
                  width: 120px;
                  border-radius: 0px 5px 5px 0px;
                "
              />
              <input
                type="date"
                id="date"
                v-model="endDate"
                style="
                  padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                  cursor: pointer;
                  width: 120px;
                  border-right: none;
                  border-radius: 5px 0 0 5px;
                "
              />
            </div>
            <b-button size="sm" @click="filterSale(page)" class="searchBtn">
              <b-icon-search></b-icon-search>
            </b-button>
          </div>

          <div style="width: 25px">
            <DropdownFilters @handleFilterDays="handleFilterDays" />
          </div>
        </div>
      </div>
    </div>
    <div class="headerCounter">
      <b-button
        class="BtnCounter"
        @click="handleTypeSale('Rascunho')"
        :style="
          status === 'Rascunho' && 'background-color: transparent; color: black'
        "
      >
        <span
          style="
            width: 10px;
            height: 10px;
            background: gray;
            border-radius: 50%;
          "
        ></span>
        <span>Rascunhos</span>
        <span v-if="!status || status === 'Rascunho'">
          - {{ this.countRascunho }}</span
        >
        <span v-if="!status || status === 'Rascunho'">
          (
          {{
            canViewSummaryValues
              ? this.totalrascunho.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ ****"
          }}
          )</span
        >
      </b-button>
      <b-button
        class="BtnCounter"
        @click="handleTypeSale('Finalizado(a)')"
        :style="
          status === 'Finalizado(a)' &&
          'background-color: transparent; color: black'
        "
      >
        <span
          style="
            width: 10px;
            height: 10px;
            background: green;
            border-radius: 50%;
          "
        ></span>
        <span>Finalizadas</span>
        <span v-if="!status || status === 'Finalizado(a)'">
          - {{ this.countFinalizado }}</span
        >
        <span v-if="!status || status === 'Finalizado(a)'">
          (
          {{
            canViewSummaryValues
              ? this.totalfinalizado.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ ****"
          }}
          )</span
        >
      </b-button>
      <b-button
        class="BtnCounter"
        @click="handleTypeSale('Cancelado')"
        :style="
          status === 'Cancelado' &&
          'background-color: transparent; color: black'
        "
      >
        <span
          style="width: 10px; height: 10px; background: red; border-radius: 50%"
        ></span>
        <span>Canceladas</span>
        <span v-if="!status || status === 'Cancelado'">
          - {{ this.countCancelado }}
        </span>
        <span v-if="!status || status === 'Cancelado'"
          >(
          {{
            canViewSummaryValues
              ? this.totalcancelado.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ ****"
          }}
          )
        </span>
      </b-button>
    </div>
    <div class="generalContainer">
      <div class="rowProvisionService" v-if="spinGeneral">
        <div class="loadingLazy">
          <div class="loader">
            <span>WINFIT</span>
            <span>WINFIT</span>
          </div>
          <span>Buscando Informações...</span>
        </div>
      </div>
      <div class="rowProvisionService" v-else>
        <div class="ContentTable" v-if="this.dataLength > 0">
          <div class="headerTable">
            <div class="celTable" style="width: 30px; text-align: center">
              <input
                type="checkbox"
                style="width: 15px; margin: 8px"
                :checked="salesSelecteds.length >= 1"
                @click.stop="selectAllReceitas"
              />
            </div>
            <div class="celTable" style="width: 2%; text-align: center"></div>
            <div class="celTable" style="width: 2%; text-align: center"></div>
            <div class="celTable" style="width: 2%; text-align: center">Nº</div>
            <div class="celTable" style="width: 10%">Data</div>
            <div class="celTable" style="width: 35%">Cliente</div>
            <div class="celTable" style="width: 15%">Resp.Técnico</div>
            <div class="celTable" style="width: 10%">Valor</div>
            <div class="celTable" style="width: 9%">Emissão</div>
            <div class="celTable" style="width: 10%">Situação</div>
            <div class="celTableActions">Ações</div>
          </div>

          <div
            v-for="(dataSearchSale, index) in dataSale"
            :key="dataSearchSale.id"
            class="rowSupplier"
            @click.stop="editSales(dataSearchSale)"
            :class="{ expanded: expandedId === index }"
          >
            <div class="lineTable" :class="{ show: expandedId === index }">
              <div class="celTable" style="width: 30px">
                <div>
                  <input
                    type="checkbox"
                    style="width: 15px"
                    :checked="salesSelecteds.includes(dataSearchSale.id)"
                    @click.stop="
                      salesSelecteds.includes(dataSearchSale.id)
                        ? (salesSelecteds = salesSelecteds.filter(
                            (e) => e != dataSearchSale.id
                          ))
                        : salesSelecteds.push(dataSearchSale.id)
                    "
                  />
                </div>
              </div>
              <div
                class="celTable"
                @click.stop="toggleCollapse(index)"
                style="
                  width: 30px;
                  align-items: center;
                  justify-content: center;
                  border-right: 1px solid gray;
                  border-left: 1px solid gray;
                  height: 100%;
                "
              >
                <b-icon-chevron-double-down
                  scale="1.4"
                  class="icon-chevron"
                  :class="{ 'icon-rotated': expandedId === index }"
                  style="color: #006256"
                />
              </div>
              <div
                class="celTable"
                style="
                  width: 2%;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                "
              >
                <div v-if="enviandoReporting === dataSearchSale.id">
                  <span style="padding: 10px"><b-spinner small /></span>
                </div>
                <div
                  class="celTable"
                  style="
                    width: 2%;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                  "
                  v-else
                >
                  <span
                    v-if="dataSearchSale.status === 'Finalizado(a)'"
                    class="ballStatus"
                    style="background: green"
                  >
                  </span>
                  <span
                    v-if="dataSearchSale.status === 'Cancelado'"
                    class="ballStatus"
                    style="background: red"
                  >
                  </span>
                  <span
                    v-if="dataSearchSale.status === 'Rascunho'"
                    class="ballStatus"
                    style="background: gray"
                  >
                  </span>
                </div>
              </div>
              <div
                class="celTable"
                style="
                  width: 2%;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                "
              >
                <span
                  style="
                    width: 100%;
                    font-weight: bold;
                    color: #006256;
                    font-size: 13px;
                  "
                >
                  {{ dataSearchSale.numero || 0 }}
                </span>
              </div>
              <div class="celTable" style="width: 10%">
                {{ dataSearchSale.data.split("-").reverse().join("/") }}
              </div>
              <div
                class="celTable"
                style="
                  width: 35%;
                  font-weight: bold;
                  text-transform: uppercase;
                  padding-left: 3px;
                "
              >
                {{ dataSearchSale.nomeCliente || "CONSUMIDOR FINAL" }}
              </div>

              <div class="celTable" style="width: 15%">
                {{ dataSearchSale.nomeTecnico || "Não informado" }}
              </div>

              <div class="celTable" style="width: 10%">
                {{
                  dataSearchSale.valorTotal.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </div>
              <div
                class="celTable"
                :style="`
                  color: #006256;
                  width: 9%;
                   background-color: ${
                     ['Emitida', 'Devolvida'].includes(
                       dataSearchSale.statusNota
                     )
                       ? '#ddebff'
                       : '#ffcfc9'
                   };
                  border-radius: 8px;
                `"
                v-if="
                  dataSearchSale.idNota && dataSearchSale.modelosNota === '1'
                "
              >
                NF-e
              </div>
              <div
                class="celTable"
                :style="`
                  color: #006256;
                  width: 9%;
                  background-color: ${
                    ['Emitida', 'Devolvida'].includes(dataSearchSale.statusNota)
                      ? '#d4edbc'
                      : '#ffcfc9'
                  };
                  border-radius: 8px;
                `"
                v-else-if="
                  dataSearchSale.idNota && dataSearchSale.modelosNota === '2'
                "
              >
                NFC-e
              </div>
              <div class="celTable" style="width: 9%" v-else>--</div>

              <div class="celTable" style="width: 10%">
                <div v-if="enviandoReporting === dataSearchSale.id">
                  <span style="padding: 10px"><b-spinner small /></span>
                </div>

                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                  "
                  @click.stop="
                    dataSearchSale.msgErroEnvioReceita
                      ? openMsgErroReceita(dataSearchSale.msgErroEnvioReceita)
                      : undefined
                  "
                >
                  <span>
                    <b-icon
                      v-if="dataSearchSale.msgErroEnvioReceita"
                      icon="info-circle-fill"
                      class="text-danger"
                      scale="1.2"
                    ></b-icon>
                  </span>

                  {{
                    enviandoReporting === dataSearchSale.id
                      ? ""
                      : shippingSituation(dataSearchSale.situacaoReceita)
                  }}
                </div>
              </div>
              <div class="celTableActions">
                <div class="btnActions">
                  <b-dropdown
                    id="dropdown-1"
                    class="btnActions1"
                    variant="none"
                    size="sm"
                  >
                    <template #button-content>
                      <b-icon-gear-fill
                        class="contentActions"
                      ></b-icon-gear-fill>
                    </template>

                    <b-dropdown-item @click.stop="editSales(dataSearchSale)">
                      Editar
                    </b-dropdown-item>

                    <div
                      v-if="dataSearchSale.tipo === 'Pedido'"
                      class="dropdown-submenu"
                      @mouseenter="showSubmenu = true"
                      @mouseleave="showSubmenu = false"
                    >
                      <b-dropdown-item>
                        <b-icon-arrow-left scale="1" /> Documentos
                        Fiscais</b-dropdown-item
                      >

                      <div v-if="showSubmenu" class="submenu">
                        <b-dropdown-item
                          v-if="
                            !dataSearchSale.statusNota ||
                            !['Emitida', 'Devolvida'].includes(
                              dataSearchSale.statusNota
                            )
                          "
                          @click.stop="handleSendCoupon(dataSearchSale.id)"
                          >Emitir NFC-e</b-dropdown-item
                        >

                        <b-dropdown-item
                          v-if="
                            !dataSearchSale.statusNota ||
                            !['Emitida', 'Devolvida'].includes(
                              dataSearchSale.statusNota
                            )
                          "
                          @click.stop="handleTransformToNfe(dataSearchSale.id)"
                          >Emitir NF-e</b-dropdown-item
                        >
                        <b-dropdown-item
                          @click.stop="findAndViewNote(dataSearchSale.idNota)"
                          v-if="
                            dataSearchSale.idNota !== null &&
                            dataSearchSale.statusNota &&
                            dataSearchSale.statusNota !== 'Não Enviada'
                          "
                        >
                          Visualizar
                          {{
                            dataSearchSale.modelosNota === "1"
                              ? "NF-e"
                              : "NFC-e"
                          }}
                        </b-dropdown-item>
                        <b-dropdown-item
                          @click.stop="
                            handleOpenModalAndFindFiscalDocument(
                              'modal-cancel',
                              dataSearchSale
                            )
                          "
                          v-if="
                            dataSearchSale.idNota !== null &&
                            dataSearchSale.statusNota &&
                            dataSearchSale.statusNota === 'Emitida'
                          "
                        >
                          Cancelar
                          {{
                            dataSearchSale.modelosNota === "1"
                              ? "NF-e"
                              : "NFC-e"
                          }}
                        </b-dropdown-item>
                      </div>
                    </div>

                    <div
                      v-if="dataSearchSale.tipo === 'Receita Pedido'"
                      class="dropdown-submenu"
                      @mouseenter="showSubmenuPrescription = true"
                      @mouseleave="showSubmenuPrescription = false"
                    >
                      <b-dropdown-item @click.stop.prevent>
                        <b-icon-arrow-left scale="1" />
                        Receita</b-dropdown-item
                      >

                      <div v-if="showSubmenuPrescription" class="submenu">
                        <b-dropdown-item
                          @click.stop="printReportSelect(dataSearchSale.id)"
                          >Imprimir</b-dropdown-item
                        >
                        <b-dropdown-item @click.stop="printInfoGenrl()">
                          Informações Gerais
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            !dataSearchSale.signedDate &&
                            canUseDigitalSignature(dataSearchSale.tipo)
                          "
                          @click.stop="
                            handleOpenModalConfirmSign(dataSearchSale.id)
                          "
                        >
                          Assinar Digitalmente
                        </b-dropdown-item>

                        <b-dropdown-item
                          v-if="dataSearchSale.signedDate"
                          @click.stop="
                            printReportSelect(dataSearchSale.id, true)
                          "
                        >
                          Imprimir receita assinada
                        </b-dropdown-item>

                        <b-dropdown-item
                          v-if="
                            dataSearchSale.signedDate &&
                            canUseDigitalSignature(dataSearchSale.tipo)
                          "
                          @click.stop="openModalCancelSign(dataSearchSale.id)"
                        >
                          Cancelar assinatura digital
                        </b-dropdown-item>

                        <b-dropdown-item
                          @click.stop="openRetornoEmbalagem(dataSearchSale)"
                          >Retorno Embalagem</b-dropdown-item
                        >

                        <b-dropdown-item
                          v-if="getCompanyUf === 'ES'"
                          @click.stop="
                            handleSendOrCancelReportES(
                              dataSearchSale.id,
                              dataSearchSale.protocoloES,
                              dataSearchSale.situacaoReceita
                            )
                          "
                        >
                          {{
                            !dataSearchSale.protocoloES &&
                            dataSearchSale.situacaoReceita === "nao_enviada"
                              ? "Enviar E-IDAF"
                              : dataSearchSale.protocoloES &&
                                dataSearchSale.situacaoReceita === "enviada" &&
                                "Cancelar envio E-IDAF"
                          }}
                        </b-dropdown-item>

                        <b-dropdown-item
                          v-if="getCompanyUf === 'SC'"
                          @click.stop="
                            handleSendOrCancelReportScSale(
                              dataSearchSale.id,
                              dataSearchSale.situacaoReceita
                            )
                          "
                        >
                          {{
                            ["nao_enviada"].includes(
                              dataSearchSale.situacaoReceita
                            )
                              ? "Enviar Sigen SC"
                              : "Cancelar envio Sigen SC"
                          }}
                        </b-dropdown-item>

                        <b-dropdown-item
                          v-if="getCompanyUf === 'MT'"
                          @click.stop="
                            handleSendOrCancelReportMT(
                              dataSearchSale.id,
                              dataSearchSale.situacaoReceita
                            )
                          "
                        >
                          {{
                            dataSearchSale.situacaoReceita === "nao_enviada"
                              ? "Enviar SISDEV"
                              : dataSearchSale.situacaoReceita === "enviada" &&
                                "Cancelar envio SISDEV"
                          }}
                        </b-dropdown-item>
                      </div>
                    </div>

                    <div
                      v-if="dataSearchSale.tipo === 'Receita Pedido'"
                      class="dropdown-submenu"
                      @mouseenter="showSubmenuGeneralSale = true"
                      @mouseleave="showSubmenuGeneralSale = false"
                    >
                      <b-dropdown-item @click.stop.prevent>
                        <b-icon-arrow-left scale="1" />
                        Venda</b-dropdown-item
                      >

                      <div v-if="showSubmenuGeneralSale" class="submenu">
                        <b-dropdown-item
                          @click.stop="
                            printCouponOrA4(
                              dataSearchSale.tipo,
                              dataSearchSale.id
                            )
                          "
                          >Imprimir</b-dropdown-item
                        >

                        <b-dropdown-item
                          v-if="
                            !dataSearchSale.statusNota ||
                            !['Emitida', 'Devolvida'].includes(
                              dataSearchSale.statusNota
                            )
                          "
                          @click.stop="handleSendCoupon(dataSearchSale.id)"
                          >Emitir NFC-e</b-dropdown-item
                        >

                        <b-dropdown-item
                          v-if="
                            !dataSearchSale.statusNota ||
                            !['Emitida', 'Devolvida'].includes(
                              dataSearchSale.statusNota
                            )
                          "
                          @click.stop="handleTransformToNfe(dataSearchSale.id)"
                          >Emitir NF-e</b-dropdown-item
                        >

                        <b-dropdown-item
                          @click.stop="findAndViewNote(dataSearchSale.idNota)"
                          v-if="
                            dataSearchSale.idNota !== null &&
                            dataSearchSale.statusNota &&
                            dataSearchSale.statusNota !== 'Não Enviada'
                          "
                        >
                          Visualizar
                          {{
                            dataSearchSale.modelosNota === "1"
                              ? "NF-e"
                              : "NFC-e"
                          }}
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            dataSearchSale.idNota &&
                            dataSearchSale.statusNota === 'Emitida'
                          "
                          @click.stop="
                            openRemoveFiscalAssociationModal(dataSearchSale.id)
                          "
                        >
                          Remover vínculo com NF-e/NFC-e
                        </b-dropdown-item>
                        <b-dropdown-item
                          @click.stop="
                            handleOpenModalAndFindFiscalDocument(
                              'modal-cancel',
                              dataSearchSale
                            )
                          "
                          v-if="
                            dataSearchSale.idNota !== null &&
                            dataSearchSale.statusNota &&
                            dataSearchSale.statusNota === 'Emitida'
                          "
                        >
                          Cancelar
                          {{
                            dataSearchSale.modelosNota === "1"
                              ? "NF-e"
                              : "NFC-e"
                          }}
                        </b-dropdown-item>
                      </div>
                    </div>

                    <b-dropdown-item
                      v-if="dataSearchSale.tipo !== 'Receita Pedido'"
                      @click.stop="
                        dataSearchSale.tipo === 'Receita'
                          ? printReportSelect(dataSearchSale.id)
                          : printCouponOrA4(
                              dataSearchSale.tipo,
                              dataSearchSale.id
                            )
                      "
                    >
                      Imprimir
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="
                        dataSearchSale.tipo === 'Receita' &&
                        canUseDigitalSignature(dataSearchSale.tipo)
                      "
                      @click.stop="printReportSelect(dataSearchSale.id, true)"
                      >Assinar Digitalmente</b-dropdown-item
                    >

                    <b-dropdown-item
                      @click.stop="findBillReportTicket(dataSearchSale.id)"
                      v-if="
                        dataSearchSale.tipo !== typeSale.orcamento &&
                        dataSearchSale.bills.length
                      "
                    >
                      Gerar Carnê
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="
                        dataSearchSale.tipo !== 'Receita' &&
                        dataSearchSale.tipo !== 'Receita Pedido'
                      "
                      @click.stop="handleDuplicateSale(dataSearchSale)"
                    >
                      Clonar
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-b-modal.modal-center4
                      @click.stop="getIdSaleDetails(dataSearchSale.id)"
                    >
                      Ver detalhes
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="
                        dataSearchSale.tipo === 'Receita' ||
                        dataSearchSale.tipo === 'Receita Pedido'
                      "
                    >
                      Inativar
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="
                        dataSearchSale.status === 'Cancelado' &&
                        dataSearchSale.tipo === 'Receita Pedido'
                      "
                      @click.stop="resusePrescription(dataSearchSale)"
                    >
                      Reutilizar numeração
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="dataSearchSale.status !== 'Cancelado'"
                      @click.stop="
                        openModalCancelPrescription(dataSearchSale.id)
                      "
                    >
                      Cancelar
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="dataSearchSale.tipo === 'Pedido'"
                      @click.stop="openModalDropSale(dataSearchSale.id)"
                    >
                      Excluir
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <div
              class="lineTableExpanded"
              :class="{ show: expandedId === index }"
            >
              <div class="celTableMoreInfo">
                <span> Informacões Cliente </span>
                <div class="rowTableMoreInfo">
                  <strong style="font-size: 10px; color: #6c6c6c">CPF:</strong>
                  {{ dataSearchSale.cpfCnpj }}
                </div>
              </div>
              <hr style="background: #d1d1d1; height: 100px; width: 1px" />
              <div class="celTableMoreInfo">
                <span> Informacões Receituário </span>
                <div class="rowTableMoreInfo">
                  <strong style="font-size: 10px; color: #6c6c6c"
                    >N° Receita:</strong
                  >
                  {{ dataSearchSale.receita || 0 }}
                </div>
                <div class="rowTableMoreInfo">
                  <strong style="font-size: 10px; color: #6c6c6c">ART:</strong>
                  {{ dataSearchSale.artTecnico }}
                </div>
                <div class="rowTableMoreInfo">
                  <strong style="font-size: 10px; color: #6c6c6c"
                    >Situação de envio:</strong
                  >
                  {{
                    getSituationPrescriptionParsed(
                      dataSearchSale.situacaoReceita
                    )
                  }}
                </div>
              </div>
              <hr style="background: #d1d1d1; height: 100px; width: 1px" />

              <div class="celTableMoreInfo" style="border: 1px solid #f5f5f5">
                <span> Informacões Financeiras </span>
                <div class="rowTableMoreInfo">
                  <strong style="font-size: 10px; color: #6c6c6c"
                    >Valor Pago:
                  </strong>
                  {{
                    dataSearchSale.totalPago
                      ? parseFloat(dataSearchSale.totalPago).toLocaleString(
                          "pt-br",
                          {
                            style: "currency",
                            currency: "BRL",
                          }
                        )
                      : parseFloat(0).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                  }}
                </div>
                <div class="rowTableMoreInfo">
                  <strong style="font-size: 10px; color: #6c6c6c"
                    >Valor Restante:
                  </strong>
                  {{
                    parseFloat(
                      dataSearchSale.valorTotal - dataSearchSale.totalPago || 0
                    ).toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </div>
                <div class="rowTableMoreInfo">
                  <strong style="font-size: 10px; color: #6c6c6c"
                    >Observacões:</strong
                  >
                  {{ dataSearchSale.observacoesReceita || "Não Informado" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 40vh;
            max-height: 100vh;
            overflow: auto;
            padding: 10px 20px;
            width: 100%;
            max-width: 100%;
          "
        >
          <span style="font-size: 1rem; font-weight: bold; color: gray"
            >Não há dados para exibir ...</span
          >
        </div>
      </div>
    </div>
    <b-modal
      id="modal-center3"
      hide-footer
      hide-header
      centered
      title="Excluir"
    >
      <div>
        <h6 class="titleModal">Deseja excluir essa movimentação ?</h6>
        <div class="btnModal">
          <button class="btnContent" @click="deleteSale">Deletar</button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center3')"
          >
            Não, Obrigado!
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-cancel" hide-footer hide-header centered title="Excluir">
      <div>
        <h4 class="titleModal" style="text-align: center">
          Deseja cancelar essa {{ nameFiscalDocument }} ?
        </h4>
        <div class="btnModalCancel">
          <div class="contentMotivo">
            <label>Descreva o motivo do cancelamento:</label> <span>*</span>
            <b-form-textarea
              placeholder="Min: 15 caracteres"
              style="color: black; width: 100% !important"
              v-model="motivo"
            ></b-form-textarea>
          </div>
          <div class="contentBtns">
            <button class="btnContent" @click="cancelNota()">
              Cancelar {{ nameFiscalDocument }}
            </button>
            <button
              class="btnContentReceive"
              @click="$bvModal.hide('modal-cancel')"
            >
              Não, Obrigado!
            </button>
          </div>
        </div>
        <span class="alertCancel">
          O prazo máximo para cancelamento de uma {{ nameFiscalDocument }} é de
          até {{ textTimeToCancel }} após a concessão da autorização de uso.
        </span>
      </div>
    </b-modal>

    <b-modal
      id="modal-estorno"
      hide-footer
      hide-header
      centered
      size="xl"
      title="estorno"
    >
      <div>
        <div style="position: relative; display: flex; justify-content: center">
          <h6 style="font-weight: bold; text-align: center">
            Produtos da Receita
          </h6>
          <button class="closeEst" @click="$bvModal.hide('modal-estorno')">
            X
          </button>
        </div>
        <div>
          <div
            class="headerTable"
            style="font-size: 12px; justify-content: space-between"
          >
            <div class="celTable" style="width: 10%">Registro</div>
            <div class="celTable" style="width: 30%">Nome</div>
            <div class="celTable" style="width: 30%">Embalagem</div>
            <div class="celTable" style="width: 5%">Qnt.</div>
            <div class="celTable" style="width: 10%">Devolvida</div>
            <div class="celTable" style="width: 100px">A devolver</div>
          </div>
          <div
            v-for="(prod, index) in productsOfEstorno"
            :key="prod.id"
            :class="`rowEstorno`"
          >
            <div class="celTableEst" style="width: 10%">
              {{ prod.registroAgrotox }}
            </div>
            <div class="celTableEst" style="width: 30%">
              {{ prod.nome }}
            </div>

            <div class="celTableEst" style="width: 30%">
              {{ prod.embalagem }}
            </div>

            <div class="celTableEst" style="width: 5%">
              {{ prod.quantidade }}
            </div>
            <div class="celTableEst" style="width: 10%">
              {{ prod.quantDevolvida }}
            </div>
            <div class="number-control" style="width: 80px">
              <div class="number-left" @click="decrementar(index)"></div>
              <input
                type="number"
                name="number"
                disabled
                class="number-quantity"
                v-model.number="estornEmb[index]"
                :max="prod.quantidade"
                min="0"
              />
              <div
                class="number-right"
                @click="incrementar(index, prod.quantidade)"
              ></div>
            </div>
          </div>
        </div>
        <div class="ctnDelAll">
          <button
            class="btnWhiteEst"
            v-if="productsOfEstorno.some((p) => p.quantDevolvida > 0)"
            @click.stop="handleEstornoCompleto()"
          >
            Estornar Retorno Embalagem
          </button>
          <button class="btnWhiteEst" @click.stop="handleImprimir()">
            Imprimir
          </button>
          <button class="btnGreenEst" @click="estornarProdutos">
            Retorno Embalagem
          </button>
        </div>
      </div>
    </b-modal>

    <!-- <b-modal
      id="modal-center4"
      hide-footer
      hide-header
      centered
      size="lg"
      title="Detalhes"
    >
      <div class="closeModalDetails" @click="$bvModal.hide('modal-center4')">
        X
      </div>
      <div class="contentModal">
        <span><b-icon-file-text></b-icon-file-text> Informações Básicas</span>
        <div class="rowModal">
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="this.detailsSales.data"
            />
            <label class="user-label"> Data</label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.numero"
            />
            <label class="user-label"> Nº Operação </label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.status"
            />
            <label class="user-label"> Status </label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.nomeCliente"
            />
            <label class="user-label"> Cliente. </label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.cpfCnpj"
            />
            <label class="user-label"> CPF/CNPJ. </label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.nomeFuncionario"
            />
            <label class="user-label"> Funcionario. </label>
          </div>
        </div>
      </div>
      <div class="contentModal">
        <span><b-icon-box-seam></b-icon-box-seam>Produtos</span>
        <div class="rowModal">
          <table style="border-spacing: 1px 0; width: 100%">
            <thead
              style="
                color: whitesmoke;
                background: #3a4750;
                padding: 10px;
                height: 35px;
                text-align: center;
                border-spacing: 0;
              "
            >
              <tr>
                <th style="width: 10%">Nome</th>
                <th style="width: 10%">Tipo</th>
                <th style="width: 10%">Observação</th>
                <th style="width: 10%">Qtd</th>
                <th style="width: 10%">Valor Unitário</th>
                <th style="width: 10%">Desconto</th>
                <th style="width: 10%">Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="detailsSale in this.detailsSales.products"
                :key="detailsSale.id"
                style="
                  text-align: center;
                  height: 60px;
                  border-bottom: 1px solid rgb(218, 218, 218);
                "
              >
                <td>
                  {{ detailsSale.nome }}
                </td>
                <td>
                  {{ detailsSale.tipoProduto }}
                </td>
                <td>{{ detailsSale.dadosAdicionais || "--" }}</td>
                <td style="width: 10%">
                  {{ detailsSale.quantidade }}
                </td>
                <td>
                  {{ detailsSale.valorUnitario }}
                </td>
                <td>
                  {{ detailsSale.desconto || "--" }}
                </td>
                <td>
                  {{ detailsSale.valorTotal }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="contentModal" v-if="this.detailsSales.status === 'Venda'">
        <span
          ><b-icon-credit-card-fill></b-icon-credit-card-fill> Duplicatas</span
        >
        <div class="ContentTableBill">
          <div class="noContentTable" v-if="this.detailsSales.bills == ''">
            Não há duplicatas pagas registradas!
          </div>
          <table style="border-spacing: 1px 0; width: 100%" v-else>
            <thead
              style="
                color: whitesmoke;
                background: #3a4750;
                padding: 10px;
                height: 35px;
                text-align: center;
                border-spacing: 0;
              "
            >
              <tr>
                <th style="width: 10%">Data</th>
                <th style="width: 10%">Data Pagamento</th>
                <th style="width: 10%">Conta</th>
                <th style="width: 10%">Tipo</th>
                <th style="width: 10%">Status</th>
                <th style="width: 10%">Forma de Pagamento</th>
                <th style="width: 10%">Vl Total</th>
                <th style="width: 10%">Vl Pago</th>
                <th style="width: 6%">Excluir</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="dataBill in this.detailsSales.bills"
                :key="dataBill.id"
                style="
                  text-align: center;
                  height: 60px;
                  border-bottom: 1px solid rgb(218, 218, 218);
                "
              >
                <td>
                  {{
                    dataBill.data.split(" ")[0].split("-").reverse().join("/")
                  }}
                </td>
                <td v-if="dataBill.dataPagamento">
                  {{
                    dataBill.dataPagamento
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}
                </td>
                <td v-else>--</td>
                <td>{{ dataBill.nomeConta }}</td>
                <td>{{ dataBill.tipo }}</td>
                <td class="contentStatus" v-if="!dataBill.dataPagamento">
                  <b-icon-x-circle-fill
                    class="statusPaymentOpen"
                  ></b-icon-x-circle-fill>
                  <span style="width: 50%">Em aberto</span>
                </td>
                <td class="contentStatus" v-else>
                  <b-icon-check-circle-fill
                    class="statusPayment"
                  ></b-icon-check-circle-fill>
                  <span style="width: 50%">Pago</span>
                </td>
                <td v-if="dataBill.dataPagamento">
                  {{ dataBill.tipoFormaPagamento }}
                </td>
                <td v-else>--</td>
                <td>
                  {{
                    dataBill.valorTotal.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </td>
                <td>
                  {{
                    dataBill.valorPago.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </td>
                <td>
                  <b-icon-x-circle
                    scale="1.5"
                    class="delBill"
                    @click="deleteBill(dataBill.id)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal> -->

    <ModalDetailsSales
      modalName="modal-center4"
      headerIcon="b-icon-exclamation-triangle-fill"
      :sale="detailsSales"
    />

    <div class="setBtn">
      <button class="itemBtn" :disabled="page == 1" @click="previousPage(page)">
        <b-icon-chevron-left></b-icon-chevron-left>
      </button>
      <button class="centerItemBtn">{{ page }}</button>
      <button
        class="itemBtn"
        :disabled="this.dataLength < 9"
        @click="nextPage(page)"
      >
        <b-icon-chevron-right></b-icon-chevron-right>
      </button>
    </div>
    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModalSales" @click="modalHeight"> X </b-button>
        <Prescription
          v-if="this.typeDocument.venda"
          :typeComponent="outsideTypeSale"
          :isReuse="isReuse"
        />
      </div>
    </div>

    <b-modal
      id="modal-select-products-fiscal-document"
      hide-footer
      centered
      size="lg"
      title="Selecionar produtos para o documento fiscal"
    >
      <div class="selectProductsFiscalModal">
        <div class="selectProductsFiscalHeader">
          <b-form-checkbox
            :checked="allFiscalProductsSelected"
            @change="toggleAllFiscalProducts"
          >
            Selecionar todos
          </b-form-checkbox>

          <strong>
            Total selecionado:
            {{
              selectedFiscalProductsTotal.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </strong>
        </div>

        <div class="selectProductsFiscalList">
          <label
            v-for="product in fiscalDocumentProducts"
            :key="product.id"
            class="selectProductsFiscalItem"
          >
            <b-form-checkbox
              :value="product.id"
              v-model="selectedFiscalProductIds"
            />
            <div class="selectProductsFiscalInfo">
              <strong>{{ product.nome }}</strong>
              <span>
                Qtde: {{ product.quantidade }} | Unitario:
                {{ formatCurrency(product.valorUnitario) }} | Total:
                {{ formatCurrency(getFiscalProductTotal(product)) }}
              </span>
            </div>
          </label>
        </div>

        <div class="selectProductsFiscalActions">
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="$bvModal.hide('modal-select-products-fiscal-document')"
          >
            Cancelar
          </b-button>
          <b-button
            size="sm"
            variant="success"
            :disabled="!selectedFiscalProductIds.length"
            @click="confirmFiscalDocumentProductSelection"
          >
            Confirmar e emitir
          </b-button>
        </div>
      </div>
    </b-modal>

    <Loading v-if="spinLoading" :text="textToModalLoading" />

    <ModalConfirm
      modalName="check-customer-general-sale"
      title="Exibir dados do cliente na NFC-e ?"
      subtitle="Exibe CPF, nome e endereço do cliente na emissão."
      rightButtonText="Não"
      leftButtonText="Sim, exibir"
      typeModal="info"
      headerIcon="b-icon-patch-exclamation-fill"
      :rightButtonClick="() => confirmSendCoupon(false)"
      :leftButtonClick="() => confirmSendCoupon(true)"
    />

    <ModalConfirm
      modalName="drop-sale"
      title="Deseja realmente excluir ?"
      subtitle="Atenção! Esta ação não poderá ser desfeita. Ao confirmar, o registro e todas as parcelas financeiras associadas serão excluídos permanentemente."
      rightButtonText="Sim"
      leftButtonText="Não excluir"
      typeModal="danger"
      headerIcon="b-icon-exclamation-triangle-fill"
      :rightButtonClick="deleteSale"
    />

    <ModalConfirm
      modalName="modal-remove-fiscal-association"
      title="Remover vínculo com documento fiscal?"
      subtitle="O vínculo da NF-e/NFC-e com a venda será removido. Esta ação não poderá ser desfeita. Deseja continuar?"
      rightButtonText="Sim, remover vínculo"
      leftButtonText="Não, manter vínculo"
      typeModal="danger"
      headerIcon="b-icon-exclamation-triangle-fill"
      :rightButtonClick="removeFiscalAssociation"
      @modalClosed="saleIdToRemoveFiscalAssociation = null"
    />

    <ModalConfirm
      modalName="modal-confirm-cancel-sign"
      title="Cancelar assinatura da Receita ?"
      subtitle="Esta ação irá cancelar a assinatura receita. Deseja realmente cancelar?"
      rightButtonText="Sim"
      leftButtonText="Não cancelar"
      :rightButtonClick="cancelSign"
    />

    <ModalConfirm
      modalName="modal-confirm-cancel-prescription"
      title="Cancelar receita"
      subtitle="Esta ação irá cancelar a receita. O número da ART poderá ser reutilizado em uma nova emissão. Deseja realmente cancelar?"
      :rightButtonClick="cancelPrescription"
      rightButtonText="Sim"
    />

    <ModalConfirm
      typeModal="info"
      modalName="modal-confirm-sign"
      title="Assinar Receita Digitalmente"
      subtitle="Deseja assinar digitalmente esta receita?"
      headerIcon="b-icon-patch-exclamation-fill"
      rightButtonText="Cancelar"
      leftButtonText="Assinar Digitalmente"
      :leftButtonClick="handleSignPrescription"
      @modalClosed="selectedPrescriptionId = null"
    />

    <ModalConfirm
      typeModal="info"
      modalName="alert-modal-reports"
      title="Erro ao enviar movimentação"
      subtitle="Identificamos que ocorreu um problema ao enviar essa movimentação para o órgão do estado"
      headerIcon="b-icon-patch-exclamation-fill"
      leftButtonText="Fechar"
      :showRightButton="false"
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.5rem;
          border-radius: 5px;
          padding: 0.5rem 0 1rem 0;
        "
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0.5rem 1.2rem 0 1.2rem;
          "
        >
          <div style="display: flex; gap: 0.6rem; align-items: center">
            <div class="contentNewAlertIcon">
              <b-icon-info-circle style="color: red" scale="0.9" />
            </div>

            <p
              style="
                margin: 0 0 0 0;
                font-size: 0.8rem;
                font-family: Poppins-Bold, sans-serif !important;
              "
            >
              Corrija os erros abaixo!
            </p>
          </div>

          <p
            style="
              margin: 0;
              background-color: rgb(255 0 0 / 12%);
              border-radius: 50px;
              padding: 0.15rem 0.8rem;
              font-size: 0.65rem;
              color: brown;
            "
          >
            {{
              reportErrors.length === 1
                ? `${reportErrors.length} Erro`
                : `${reportErrors.length} Erros`
            }}
          </p>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 0.8rem;
            overflow: auto;
            width: 100%;
            max-height: 200px;
            padding: 0.2rem 1.2rem 0.6rem 1.2rem;
          "
        >
          <div
            v-for="(errors, idx) in reportErrors"
            :key="idx"
            class="contentReportError"
          >
            <div
              style="
                min-width: 23px;
                min-height: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgb(255 0 0 / 12%);
                border-radius: 50%;
                font-size: 0.68rem;
                color: brown;
              "
            >
              {{ idx + 1 }}
            </div>

            <p
              style="
                margin: 0;
                font-size: 0.75rem;
                color: oklch(44.6% 0.03 256.802);
                font-family: Poppins-Medium, sans-serif !important;
              "
            >
              {{ errors }}
            </p>
          </div>
        </div>
      </div>
    </ModalConfirm>
  </div>
</template>
<script>
import axios from "axios";

import { DateTime } from "luxon";
import { mapMutations, mapState } from "vuex";
import api from "../../services/axios";

import Prescription from "../Prescription/Prescription.vue";
import Loading from "../Loading/Loading.vue";
import ModalConfirm from "../Modals/ModalConfirm.vue";
import ModalDetailsSales from "./ModalDetailsSales.vue";
import DropdownFilters from "../../components/UI/DropdownFilters/DropdownFilters.vue";

import ServiceSale from "../../services/serviceSale";
import ServiceBill from "../../services/serviceBill";
import ServiceNotaFiscal from "../../services/serviceNotaFiscal";

import { TypeSale } from "../../utils/enums/SalesType";
import { TypeErrors } from "../../utils/enums/TypeErrors";
import { TypesOfSales } from "../../utils/enums/TypesOfSales";
import { BillColumnsToSearchById } from "../../utils/enums/BillColumnsToSearchById";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import printReport from "../../reports/sale";
import { formatValuesFromSales } from "../../helpers/generalSales";
import serviceSale from "../../services/serviceSale";
import serviceProductSale from "../../services/serviceProductSale";
import { printEstorno } from "../../reports/Products/Estorno";
import { hasDigitalSignaturePermission } from "../../utils/digitalSignaturePermission";
import { hasSummaryValuesPermission } from "../../utils/summaryValuesPermission";

export default {
  components: {
    Prescription,
    Loading,
    ModalConfirm,
    ModalDetailsSales,
    DropdownFilters,
  },
  props: {
    initialMonth: {
      type: Date,
      default: () => new Date(),
    },
    outsideTypeSale: {
      type: String,
      default: "Receita Pedido",
    },
  },
  data() {
    return {
      salesSelecteds: [],
      limitOption: "9",
      reportErrors: [],
      enviandoReporting: null,
      selectTextDate: "Este mês",
      year: DateTime.local().year,
      month: DateTime.local(),
      typeSale: TypeSale,
      spinLoading: false,
      spinGeneral: false,
      expandedId: null,
      textPesquisa: "",
      type: "",
      typeOfSales: TypesOfSales.normal,
      typeSituation: "",
      status: "",
      startDate: "",
      endDate: "",
      colapseModal: false,
      modalContainer: "contentModalDisable",
      dataSale: [],
      totalcancelado: 0,
      countCancelado: 0,
      countFinalizado: 0,
      countRascunho: 0,
      totalfinalizado: 0,
      totalrascunho: 0,
      totalFaturado: 0,
      countFaturado: 0,
      dataBills: "",
      page: 1,
      dataLength: 0,
      filterCombobox: [
        { value: "nomeCliente", text: "Cliente" },
        { value: "nomeFuncionario", text: "Funcionário" },
        { value: "numero", text: "Nº Operação" },
        { value: "numeroNFe", text: "Nº NF-e" },
        { value: "receita", text: "Nº Receita" },
        { value: "situacaoReceita", text: "Situação Receita" },
        { value: "", text: "Selecione..." },
      ],
      prescriptionSituationOpts: [
        { value: "enviada", text: "Enviada" },
        { value: "enviada_parcialmente", text: "Enviada Parcialmente" },
        { value: "nao_enviada", text: "Não Enviada" },
        { value: "", text: "Selecione..." },
      ],
      limitOptions: [
        { value: "9", text: "10" },
        { value: "20", text: "20" },
        { value: "50", text: "50" },
      ],
      filterSalePerType: [
        { value: "Frente De Caixa", text: "Frente De Caixa" },
        { value: "Venda", text: "Venda" },
        { value: "Orçamento", text: "Orçamento" },
        { value: "", text: " Clique para selecionar o Status " },
      ],
      saleId: "",
      detailsSales: "",
      returnDataNote: null,
      motivo: "",
      responseNfeWebMania: {
        chave: "",
        danfe: "",
        danfe_etiqueta: "",
        danfe_simples: "",
        log: "",
        modelo: "",
        motivo: "",
        nfe: "",
        serie: "",
        status: "",
        uuid: "",
        xml: "",
      },
      itemSelectedInTableSearch: null,
      textToModalLoading: "",
      showSubmenu: false,
      showSubmenuPrescription: false,
      showSubmenuGeneralSale: false,
      selectedPrescriptionId: null,
      isReuse: false,
      prescriptionSituation: "nao_enviada",
      productsOfEstorno: [],
      receiptForEstorno: {},
      estornEmb: [],
      fiscalDocumentSelectionType: "",
      fiscalDocumentSelectionSaleId: "",
      fiscalDocumentProducts: [],
      selectedFiscalProductIds: [],
      saleIdToRemoveFiscalAssociation: null,
    };
  },
  methods: {
    canUseDigitalSignature(saleType) {
      const permissionTypes = {
        Receita: "novaReceita",
        "Receita Pedido": "novoPedidoCompleto",
      };
      const permissionType = permissionTypes[saleType];
      return !!permissionType && hasDigitalSignaturePermission(permissionType);
    },

    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "ALTER_TYPE_DOCUMENT",
      "SET_DATA_SEARCH_FROM_BOX_FRONT",
      "SET_DATA_SEARCH_FROM_SALE",
      "SET_ID_TRANSFORM_COMPLETED_SALE",
      "SET_HTML_TO_PRINT",
    ]),

    async enviarEmLote() {
      await api.post("/sales/bulk-sales/send/report", {
        ids: this.salesSelecteds,
      });

      this.$toast.open({
        message: "Envio em lote realizado com sucesso!",
        type: "success",
      });
    },

    openMsgErroReceita(msg) {
      this.reportErrors = [msg];
      this.$bvModal.show("alert-modal-reports");
    },

    shippingSituation(shippingType) {
      const types = {
        enviada: "Enviada",
        enviada_parcialmente: "Enviada Parcialmente",
        nao_enviada: "Não Enviada",
      };

      return types[shippingType];
    },

    async selectAllReceitas() {
      if (this.salesSelecteds.length >= 1) {
        this.salesSelecteds = [];
        return;
      }

      const ids = this.dataSale
        .filter((e) => e.situacaoReceita === "nao_enviada")
        .map((e) => e.id);

      this.salesSelecteds = ids;
    },

    async cancelSign() {
      const sale = this.dataSale.find(({ id }) => id === this.prescriptionId);
      if (!this.canUseDigitalSignature(sale?.tipo)) return;

      await api.get(`/sales/cancell/sign/${this.prescriptionId}`);

      this.$toast.open({
        message: "Assinatura cancelada com sucesso!",
        type: "success",
      });

      await this.filterSale(1);
    },

    async openModalCancelSign(id) {
      const sale = this.dataSale.find((item) => item.id === id);
      if (!this.canUseDigitalSignature(sale?.tipo)) return;

      this.prescriptionId = id;

      this.openModals("modal-confirm-cancel-sign");
    },

    async handleSendOrCancelReportES(id, protocoloES, situacaoReceita) {
      this.enviandoReporting = id;

      try {
        if (!protocoloES && situacaoReceita === "nao_enviada")
          await this.sendReport(id);
        else if (protocoloES && situacaoReceita === "enviada")
          await this.cancelReport(id);

        await this.filterSale(this.page);
        this.$toast.success("Relatório enviado com sucesso.");
      } catch (err) {
        if (axios.isAxiosError(err)) {
          let msg = err?.response?.data?.messageErrors ?? [];

          this.reportErrors = msg;
        }
      } finally {
        this.enviandoReporting = null;
        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },

    async handleSendOrCancelReportMT(id, situacaoReceita) {
      this.enviandoReporting = id;

      try {
        if (situacaoReceita === "nao_enviada") await this.sendReport(id);
        else if (situacaoReceita === "enviada") await this.cancelReport(id);

        await this.filterSale(this.page);
        this.$toast.success("Relatório enviado com sucesso.");
      } catch (err) {
        if (axios.isAxiosError(err)) {
          let msg = err?.response?.data?.messageErrors ?? [];

          this.reportErrors = msg;
        }
      } finally {
        this.enviandoReporting = null;
        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },

    async handleSendOrCancelReportScSale(id, situacaoReceita) {
      try {
        if (situacaoReceita === "nao_enviada") await this.sendReport(id);
        else if (
          situacaoReceita === "enviada" ||
          situacaoReceita === "enviada_parcialmente"
        )
          await this.cancelReport(id);

        await this.filterSale(this.page);
        this.$toast.success("Relatório enviado com sucesso.");
      } catch (err) {
        if (axios.isAxiosError(err)) {
          let msg = err?.response?.data?.messageErrors ?? [];

          this.reportErrors = msg;
        }
      } finally {
        this.enviandoReporting = null;
        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },

    async sendReport(id) {
      this.enviandoReporting = id;

      try {
        await serviceSale.sendReport(id);

        this.$toast.success("Relatório enviado com sucesso.");
      } catch (err) {
        if (axios.isAxiosError(err)) {
          let msg = err?.response?.data?.messageErrors ?? [];

          this.reportErrors = msg;
        }
      } finally {
        this.enviandoReporting = null;
        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },

    async cancelReport(id) {
      this.enviandoReporting = id;

      try {
        await serviceSale.cancelReport(id);

        this.$toast.success("Cancelamento da receita enviado!");
      } catch (err) {
        if (axios.isAxiosError(err)) {
          let msg = err?.response?.data?.messageErrors ?? [];

          this.reportErrors = msg;
        }
      } finally {
        this.enviandoReporting = null;
        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },
    async openModalCancelPrescription(id) {
      this.prescriptionId = id;

      this.openModals("modal-confirm-cancel-prescription");
    },
    openModals(name) {
      this.$bvModal.show(name);
    },

    async cancelPrescription() {
      try {
        if (this.prescriptionId) {
          await serviceSale.cancel(this.prescriptionId);
          await this.filterSale(1);
          this.$toast.open({
            message: "Receita cancelada!",
            type: "success",
          });
        }
      } catch (error) {
        const message =
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message;

        this.$toast.info(message || "Erro ao emitir a receita.");
      }
    },

    toggleCollapse(index) {
      this.expandedId = this.expandedId === index ? null : index;
    },
    getIdSale(idSale) {
      this.saleId = idSale;

      this.findBill();
    },

    async getIdSaleDetails(idSale) {
      this.detailsSales = await this.findCompletedSale(idSale);
      this.saleId = idSale;

      const dataSalesFormated = this.detailsSales.data
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");

      this.detailsSales.data = dataSalesFormated;

      console.log(this.detailsSales);
    },

    async findBill() {
      this.detailsSales.bills = await ServiceBill.getAllBillsByParamsId(
        this.saleId,
        BillColumnsToSearchById.idVenda
      );
    },

    async findBillReportTicket(idSale) {
      const token = localStorage.getItem("token");
      this.saleId = idSale;
      window.open(
        `${process.env.VUE_APP_URL_BACKEND}/bills/print/report/ticket/all/bills/and/format/carne/completed/with/pix/one/${this.saleId}?auth=${token}`
      );
    },

    async deleteBill(id) {
      await ServiceBill.deleteAllRelationshipsFromDuplicate(id);

      this.findBill();
    },

    async deleteSale() {
      try {
        this.spinGeneral = true;
        await ServiceSale.deleteAll(this.saleId);

        await this.filterSale(1);
        this.$bvModal.hide("modal-center3");
        return this.$toast.open({
          message: "Venda removida com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateMessage(error, this.$toast);
      } finally {
        this.spinGeneral = false;
      }
    },

    async filterSale(page, byStatus, bySituation) {
      if (this.selectTextDate === "Personalizado") {
        if (this.startDate && this.endDate) {
          const start = DateTime.fromISO(this.startDate);
          const end = DateTime.fromISO(this.endDate);
          const diffInMonths = end.diff(start, "months").months;

          if (diffInMonths > 6) {
            this.$toast.open({
              message:
                "Atenção! Período superior a 6 meses.Para esse intervalo, utilize o módulo Relatórios.",
              type: "info",
            });
            return;
          }

          if (end < start) {
            this.$toast.open({
              message: "A data final não pode ser anterior à data inicial",
              type: "warning",
            });
            return;
          }
        }
      }

      try {
        this.spinGeneral = true;

        if (!byStatus) this.status = "";

        if (!bySituation) this.prescriptionSituation = "";

        const { data } = await api.get(
          `/sales?q=${this.textPesquisa}&type=${this.type}&status=${this.status}&situacaoReceita=${this.prescriptionSituation}&page=${page}&startDate=${this.startDate}&endDate=${this.endDate}&typeSale=${this.outsideTypeSale}&limit=${this.limitOption}`
        );

        if (!Object.keys(data).length) {
          return;
        }

        this.dataLength = data.data.length;
        this.dataSale = data.data.map((sale) => {
          if (sale.bills.length) {
            const totalPago = sale.bills?.reduce(
              (sum, bill) => sum + bill.valorPago,
              0
            );
            return { ...sale, totalPago };
          }

          return sale;
        });
        if (data.totals && Object.keys(data.totals).length) {
          this.countCancelado = data.totals.countCancelado;
          this.countFinalizado = data.totals.countFinalizado;
          this.countRascunho = data.totals.countRascunho;
          this.countFaturado = data.totals.countFaturado;

          this.totalcancelado = data.totals.cancelado;
          this.totalfinalizado = data.totals.finalizado;
          this.totalrascunho = data.totals.rascunho;
          this.totalFaturado = data.totals.faturado;
        }
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar informações",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    async handleFilterDays(valueDate, textValueDate) {
      this.clearSearch();
      this.selectTextDate = textValueDate;

      const today = DateTime.local();

      switch (valueDate) {
        case "hoje":
          this.startDate = today.toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "esteMes":
          this.startDate = today.startOf("month").toSQLDate();
          this.endDate = today.endOf("month").toSQLDate();
          break;
        case "ontem":
          // eslint-disable-next-line no-case-declarations
          const yesterday = today.minus({ days: 1 });
          this.startDate = yesterday.toSQLDate();
          this.endDate = yesterday.toSQLDate();
          break;
        case "7dias":
          this.startDate = today.minus({ days: 7 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "30dias":
          this.startDate = today.minus({ days: 30 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "mesPassado":
          // eslint-disable-next-line no-case-declarations
          const lastMonth = today.minus({ months: 1 });
          this.startDate = lastMonth.startOf("month").toSQLDate();
          this.endDate = lastMonth.endOf("month").toSQLDate();
          break;
        case "ultimos3meses":
          this.startDate = today
            .minus({ months: 3 })
            .startOf("month")
            .toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        default:
          break;
      }

      await this.filterSale(1);
    },

    async handleActionAfterNfIssuance(idSale) {
      if (this.outsideTypeSale === "Receita Pedido") {
        const options = {
          imprimirReceita: async () =>
            await this.printReportSelect(idSale, false),
          assinarReceita: async () =>
            await this.printReportSelect(idSale, true, "Receita Pedido"),
        };

        if (
          this.getConfigActionAfterNfIssuance &&
          options[this.getConfigActionAfterNfIssuance]
        ) {
          await options[this.getConfigActionAfterNfIssuance]();
        }
      }
    },
    handleTypeSale(name) {
      this.status = name;

      this.filterSale(1, true);
    },

    nextPage() {
      this.filterSale((this.page += 1), true);
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.filterSale((this.page -= 1), true);
      }
    },

    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");
      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";

      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_BOX_FRONT({});
        this.SET_DATA_SEARCH_FROM_SALE({});
      }
      this.filterSale(1);
    },

    async editSales(sale) {
      const data = await this.searchTableDataForSale(sale.id);

      if (data && Object.keys(data).length) {
        this.handleEditSale(data);
      }
      this.page = 1;
    },

    async resusePrescription(sale) {
      await this.editSales(sale);
      await this.$nextTick();
      this.isReuse = !this.isReuse;
    },

    async searchTableDataForSale(idVenda) {
      try {
        const { data } = await api.get(`/sales/${idVenda}`);
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },

    async findCompletedSale(idVenda) {
      try {
        const { data } = await api.get(`/sales/details/${idVenda}`);
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },

    handleOpenModalConfirmSign(prescriptionId) {
      const sale = this.dataSale.find(({ id }) => id === prescriptionId);
      if (!this.canUseDigitalSignature(sale?.tipo)) return;

      this.selectedPrescriptionId = prescriptionId;
      this.$bvModal.show("modal-confirm-sign");
    },

    async handleSignPrescription() {
      const sale = this.dataSale.find(
        ({ id }) => id === this.selectedPrescriptionId
      );
      if (!this.canUseDigitalSignature(sale?.tipo)) return;

      try {
        await this.printReportSelect(this.selectedPrescriptionId, true);
      } catch (err) {
        return this.$toast.info(
          "Ocorreu um problema ao assinagar a receita digitalmente"
        );
      }
    },

    printInfoGenrl() {
      printReport("printInfo");
    },

    async printReportSelect(idSale, toSign, saleType = null) {
      try {
        if (!idSale) return;

        const sale = this.dataSale.find(({ id }) => id === idSale);
        if (
          toSign &&
          !sale?.signedDate &&
          !this.canUseDigitalSignature(sale?.tipo || saleType)
        ) {
          return this.$toast.info(
            "Este usuário não tem permissão para assinatura digital"
          );
        }

        const result = await printReport("receiptStandard", idSale, toSign);

        if ("url" in result && toSign) {
          const { data } = await axios.get(`${result.url}?v=${Date.now()}`, {
            responseType: "blob",
          });

          const blob = new Blob([data], { type: "application/pdf" });

          const pdfUrl = URL.createObjectURL(blob);

          this.SET_HTML_TO_PRINT(pdfUrl);
        } else {
          this.SET_HTML_TO_PRINT("html" in result ? result.html : result.url);
        }
      } catch (error) {
        return this.$toast.info(
          error?.response?.data?.message ||
            "Ocorreu um problema ao realizar a impressão!"
        );
      }
    },

    handleModals(name) {
      this.ALTER_TYPE_DOCUMENT(name);

      this.modalHeight();
    },

    handleEditSale(data) {
      if (this.outsideTypeSale !== "Pedido") data.tipo = "Receita Pedido";

      const formatedSale = formatValuesFromSales("Venda", data);

      this.SET_DATA_SEARCH_FROM_SALE(formatedSale);

      this.ALTER_TYPE_DOCUMENT("venda");
      this.modalHeight();
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
      this.page = 1;
    },
    async openRetornoEmbalagem(receipt) {
      this.receiptForEstorno = receipt;
      this.productsOfEstorno = await serviceProductSale.findByIdSale(
        receipt.id
      );
      this.estornEmb = this.productsOfEstorno.map(
        (prod) => prod.quantDevolvida || 0
      );

      this.openModals("modal-estorno");
    },

    incrementar(index, maxQuantity) {
      if (this.estornEmb[index] < maxQuantity) {
        this.$set(this.estornEmb, index, this.estornEmb[index] + 1);
      }
    },

    decrementar(index) {
      if (this.estornEmb[index] > 0) {
        this.$set(this.estornEmb, index, this.estornEmb[index] - 1);
      }
    },

    async estornarProdutos() {
      const produtosParaAtualizar = this.productsOfEstorno
        .map((prod, index) => {
          const novaQuantidadeDevolvida = Number(this.estornEmb[index]) || 0;

          if (
            novaQuantidadeDevolvida > 0 &&
            novaQuantidadeDevolvida !== prod.quantDevolvida
          ) {
            return {
              ...prod,
              quantDevolvida: novaQuantidadeDevolvida,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      if (produtosParaAtualizar.length === 0) {
        this.$bvModal.hide("modal-estorno");
        return;
      }

      try {
        await api.put(
          `/products-of-sale/update/and/print`,
          produtosParaAtualizar
        );

        printEstorno(this.receiptForEstorno.id);
        this.$bvModal.hide("modal-estorno");
      } catch (error) {
        console.error("Erro ao estornar produtos:", error);
      }
    },
    async handleEstornoCompleto() {
      try {
        const products = await serviceProductSale.findByIdSale(
          this.receiptForEstorno.id
        );

        const produtosZerados = products.map((prod) => ({
          ...prod,
          quantDevolvida: 0,
        }));

        await api.put(`/products-of-sale/update/and/print`, produtosZerados);

        this.productsOfEstorno = produtosZerados;
        this.$toast.open({
          message: "Estorno realizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.error("Erro ao estornar o retorno das embalagens:", error);
      }
    },

    handleImprimir() {
      if (typeof printEstorno === "function") {
        printEstorno(this.receiptForEstorno.id);
      }
    },

    openRemoveFiscalAssociationModal(idSale) {
      this.saleIdToRemoveFiscalAssociation = idSale;
      this.$bvModal.show("modal-remove-fiscal-association");
    },

    async removeFiscalAssociation() {
      const idSale = this.saleIdToRemoveFiscalAssociation;
      if (!idSale) return;

      try {
        await api.get(`/nota/remove-association-nfe-by-sale/${idSale}`);
        await this.filterSale(this.page);

        this.$toast.open({
          message: "Vínculo com o documento fiscal removido com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Não foi possível remover o vínculo com o documento fiscal.",
          type: "error",
        });
      }
    },

    async handleTransformToNfe(idSale) {
      if (!this.shouldSelectProductsBeforeFiscalDocument) {
        return this.transformToNfe(idSale);
      }

      await this.openFiscalDocumentProductSelection(idSale, "nfe");
    },

    async handleSendCoupon(idSale) {
      if (!this.shouldSelectProductsBeforeFiscalDocument) {
        this.fiscalDocumentSelectionSaleId = idSale;
        this.fiscalDocumentSelectionType = "nfce";
        this.selectedFiscalProductIds = [];

        return this.$bvModal.show("check-customer-general-sale");
      }

      await this.openFiscalDocumentProductSelection(idSale, "nfce");
    },

    async openFiscalDocumentProductSelection(idSale, type) {
      const sale = await this.searchTableDataForSale(idSale);
      const products = (sale?.products || []).filter(
        (product) => product.tipoProduto !== "composition"
      );

      if (!products.length) {
        return this.$toast.open({
          message:
            "Nenhum produto encontrado para transformar em documento fiscal",
          type: "info",
        });
      }

      this.fiscalDocumentSelectionSaleId = idSale;
      this.fiscalDocumentSelectionType = type;
      this.fiscalDocumentProducts = products;
      this.selectedFiscalProductIds = products.map((product) => product.id);
      this.$bvModal.show("modal-select-products-fiscal-document");
    },

    async confirmFiscalDocumentProductSelection() {
      if (!this.selectedFiscalProductIds.length) {
        return this.$toast.open({
          message: "Selecione ao menos um produto",
          type: "info",
        });
      }

      this.$bvModal.hide("modal-select-products-fiscal-document");

      if (this.fiscalDocumentSelectionType === "nfe") {
        return this.transformToNfe(
          this.fiscalDocumentSelectionSaleId,
          this.selectedFiscalProductIds
        );
      }

      return this.$bvModal.show("check-customer-general-sale");
    },

    toggleAllFiscalProducts(checked) {
      this.selectedFiscalProductIds = checked
        ? this.fiscalDocumentProducts.map((product) => product.id)
        : [];
    },

    getFiscalProductTotal(product) {
      const total = Number(product.valorTotal || 0);
      const discount = Number(product.desconto || 0);

      return +(total - discount).toFixed(2);
    },

    formatCurrency(value) {
      return Number(value || 0).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },

    async transformToNfe(idSale, selectedProductIds = []) {
      try {
        this.spinLoading = true;
        this.textToModalLoading = "Aguarde! A Sua NF-e está sendo emitida !";

        const nfe = await ServiceSale.transformInNotaToSend(
          idSale,
          selectedProductIds
        );

        await this.filterSale(this.page);

        await this.findAndViewNote(nfe.id);

        await this.handleActionAfterNfIssuance(idSale);
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && typeError?.nameError === TypeErrors.NO_PERMISSIONS) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        return this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ops! Houve algum erro. Verifique os dados e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
      }
    },

    async handleDuplicateSale(dataSearchSale) {
      const data = await this.formatValuesToDuplicate(dataSearchSale.id);

      if (Object.keys(data).length) {
        data.numero = "";

        this.handleEditSale(dataSearchSale.tipo, data);
      }

      return;
    },

    async formatValuesToDuplicate(idSale) {
      const data = await this.searchTableDataForSale(idSale);

      const newProductsSale = data.products.map((prod) => {
        prod.id = "";
        prod.idVenda = "";

        return prod;
      });

      data.id = "";
      data.products = newProductsSale;
      data.bills = [];

      return data;
    },

    confirmSendCoupon(isLeaveClient) {
      return this.sendCoupon(
        this.fiscalDocumentSelectionSaleId,
        this.selectedFiscalProductIds,
        isLeaveClient
      );
    },

    async sendCoupon(idSale, selectedProductIds = [], isLeaveClient = false) {
      try {
        this.spinLoading = true;
        this.textToModalLoading = "Aguarde! O Seu cupom está sendo emitido !";

        const data = await ServiceNotaFiscal.sendCoupon(
          idSale,
          isLeaveClient,
          "",
          selectedProductIds
        );
        this.responseNfeWebMania.danfe = data.dataWebMania.danfe;

        this.$toast.open({
          message: "Cupom Fiscal emitido com sucesso!",
          type: "success",
        });

        await this.filterSale(this.page);

        await this.findAndViewNote(data.id);

        await this.handleActionAfterNfIssuance(idSale);
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && typeError?.nameError === TypeErrors.NO_PERMISSIONS) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        return this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ops! Houve algum erro. Verifique os dados e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
        this.fiscalDocumentSelectionType = "";
        this.fiscalDocumentSelectionSaleId = "";
        this.fiscalDocumentProducts = [];
        this.selectedFiscalProductIds = [];
      }
    },

    openModalDropSale(saleId) {
      this.saleId = saleId;
      this.$bvModal.show("drop-sale");
    },

    visualizarNfe(danfe) {
      window.open(danfe, "_blank", "width=700, height=800, top=500, left=500");
    },

    async findNotaById(idNota) {
      this.returnDataNote = await ServiceNotaFiscal.findNotaById(idNota);
    },

    async findAndViewNote(idNota) {
      const notaReturn = await ServiceNotaFiscal.findNotaById(idNota);
      if (notaReturn.status === "Não Enviada") {
        this.$toast.open({
          message:
            "Houve um erro! Verifique se o documento foi emitido e tente novamente",
          type: "info",
        });
      } else {
        notaReturn.modelo == 1
          ? await this.printNf(notaReturn.id)
          : await this.printNfce(notaReturn.id);
      }
    },
    async printNf(id) {
      try {
        const pdfUrl = await ServiceNotaFiscal.printNf(id);

        window.open(pdfUrl, "_blank");
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },

    async printNfce(id) {
      try {
        const danfe = await ServiceNotaFiscal.printNfce(id);

        const win = window.open(
          danfe,
          "_blank",
          "width=700, height=800, top=500, left=500"
        );

        win.document.write(danfe);

        win.document.close();
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },
    async cancelNota() {
      try {
        const dataCancelamento = {
          uuid: this.returnDataNote.response.uuid,
          motivo: this.motivo,
        };
        this.spinLoading = true;
        this.textToModalLoading =
          "Aguarde! O Seu documento fiscal está sendo cancelado !";

        await ServiceNotaFiscal.cancelNota(
          dataCancelamento,
          this.returnDataNote.id
        );

        this.$toast.open({
          message: `${this.nameFiscalDocument} cancelada!`,
          type: "success",
        });

        await this.filterSale(1);
      } catch (error) {
        this.$toast.open({
          message: "Houve um erro! Verifique e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
        this.motivo = "";
      }
    },

    printCouponOrA4(type, idSale) {
      if (type === this.typeSale.frenteDeCaixa) {
        this.printReportCoupon(idSale);
      } else {
        this.printReportVendaOrcamento(idSale);
      }
    },

    printReportCoupon(idSale) {
      printReport("reportCoupon", idSale);
    },

    printReportVendaOrcamento(idSale) {
      printReport("reportVendaOrcamento", idSale);
    },

    getSituationPrescriptionParsed(situation) {
      const situations = {
        enviada: "Enviada",
        enviada_parcialmente: "Enviada Parcialmente",
        nao_enviada: "Não Enviada",
      };

      return situations[situation] || "";
    },

    async handleOpenModalAndFindFiscalDocument(nameModal, dataSearchSale) {
      this.itemSelectedInTableSearch = dataSearchSale;
      this.findNotaById(dataSearchSale.idNota);
      this.openModal(nameModal);
    },

    openModal(nameModal) {
      this.$bvModal.show(nameModal);
    },

    openModalVenda() {
      this.ALTER_TYPE_DOCUMENT("venda");
      this.modalHeight();
    },

    delayToOpen() {
      setTimeout(() => {
        this.openModalVenda();
      }, 500);
    },
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
      typeDocument: (state) => state.typeDocument,
      idTransformCompletedSale: (state) => state.idTransformCompletedSale,
      dataConfig: (state) => state.dataConfig,
      dataCompany: (state) => state.dataCompany,
    }),
    monthName() {
      return this.month.toLocaleString({ month: "long", locale: "pt-BR" });
    },
    canViewSummaryValues() {
      return hasSummaryValuesPermission("novoPedidoCompleto");
    },
    getCompanyUf() {
      return this.dataCompany?.uf?.toUpperCase() || "";
    },
    nameFiscalDocument() {
      return String(
        this.itemSelectedInTableSearch?.modelosNota ||
          this.returnDataNote?.modelo
      ) === "2"
        ? "NFC-e"
        : "NF-e";
    },
    textTimeToCancel() {
      return this.nameFiscalDocument === "NFC-e"
        ? "30 MINUTOS"
        : "24 HORAS";
    },
    getConfigActionAfterNfIssuance() {
      return this.dataConfig?.receita?.acaoAposEmissaoNF || null;
    },
    shouldSelectProductsBeforeFiscalDocument() {
      return (
        this.dataConfig?.emissao_fiscal?.selecionarProdutosAoTransformarVenda ||
        false
      );
    },
    allFiscalProductsSelected() {
      return (
        this.fiscalDocumentProducts.length > 0 &&
        this.selectedFiscalProductIds.length ===
          this.fiscalDocumentProducts.length
      );
    },
    selectedFiscalProductsTotal() {
      return this.fiscalDocumentProducts.reduce((total, product) => {
        if (!this.selectedFiscalProductIds.includes(product.id)) {
          return total;
        }

        return total + this.getFiscalProductTotal(product);
      }, 0);
    },
  },
  async created() {
    const today = DateTime.local();
    this.startDate = today.startOf("month").toSQLDate();
    this.endDate = today.endOf("month").toSQLDate();
    this.filterSale(1);
    this.ALTER_SIZE_MODAL("disable");

    if (this.idTransformCompletedSale) {
      const data = await this.searchTableDataForSale(
        this.idTransformCompletedSale
      );

      const formatedSale = formatValuesFromSales("Venda", data);

      this.SET_DATA_SEARCH_FROM_SALE(formatedSale);

      this.delayToOpen();
      this.SET_ID_TRANSFORM_COMPLETED_SALE(null);
    }
  },
  beforeDestroy() {
    this.ALTER_SIZE_MODAL("disable");
  },
};
</script>
<style scoped>
.GeneralSales {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: 100vh;
  font-size: 12px;
}
.headerGeneralSales {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 65px;
  background: white;
  border-radius: 5px;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.headerCounter {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 5px;
  margin: 5px 0;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.BtnRegister {
  width: 200px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 10px;
  color: #006458;
  border: 1px solid #cfe5e3;
}

.BtnRegister:hover {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.BtnCounter {
  width: 33.3%;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3ebe2;
  height: 30px;
  gap: 10px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 1px;
  color: #006458;
  border: 1px solid #7ab5ae;
}
.BtnCounter:hover {
  background: #e3ebe2;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.BtnCounter:focus {
  width: 33.3%;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3ebe2;
  height: 30px;
  gap: 10px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 1px;
  color: #006458;
  border: 1px solid #7ab5ae;
}
.Summary {
  display: flex;
  flex-direction: column;
  width: 40%;
  gap: 10px;
  justify-content: flex-start;
}

.iconItem {
  display: flex;
  width: 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}
.iconItem:hover {
  background: #006256;
  cursor: pointer;
}

.ItemSummarySales {
  height: 60px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
}

.ItemSummarySales span {
  font-size: 13px;
  cursor: context-menu;
  letter-spacing: 1px;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 30px;
}
.ContainerBtnSales {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: auto;
  margin-top: 70px;
  width: 100%;
  gap: 1rem;
}

.BtnSales {
  width: 30%;
  border: none;
  height: 35px;
  border-radius: 3px;
  font-size: 13px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.lineSearch {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.summaryMonth {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  cursor: context-menu;
  padding: 0 0 0 7px;
  color: #2e2e2e;
  display: flex;
  align-items: center;
}
.searchByMonth {
  width: 30%;
  display: flex;
  align-items: center;
  margin: 20px 0px 0px 0px;
  border-radius: 5px;
  font-size: 11px;
  justify-content: space-around;
  border: 1px solid #e3e0e0;
}

.searchFilter {
  width: 120px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}
.inputSearch {
  width: 200px;
}

.disableInput {
  display: none;
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid #e3e0e0;
  -moz-appearance: none;
  appearance: none;
  font-weight: 600;
}

.custom-select2 {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid #e3e0e0;
  -moz-appearance: none;
  appearance: none;
  background: none;
}

.btnPeriod {
  border-radius: 5px 0px 0px 5px;
  padding: 0 10px;
  border: 1px solid #e3e0e0;
  height: 30px;
  font-size: 11px;
  cursor: context-menu;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.searchInput {
  display: flex;
  justify-content: center;
}

.searchInputDate {
  width: 30%;
  display: flex;
}

.searchInputAll {
  width: 30%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.searchContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 10px;
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

.form-control {
  display: block;
  width: 230px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 12px;
  height: 30px;
}

.dateInput {
  display: flex;
  gap: 10px;
}

input {
  border: 1px solid #e3e0e0;
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 0px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #e3e0e0;
}

input:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

button:focus {
  box-shadow: none;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}

.Arrows {
  border-radius: 5px;
  width: 15px;
  height: 15px;
}

.Arrows:hover {
  background: whitesmoke;
}

.SummarySales {
  display: flex;
  width: 100%;
  padding: 15px 0;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid rgb(235, 235, 235);
}

.iconItem {
  display: flex;
  width: 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}
.ballStatus {
  width: 10px;
  height: 10px;
  font-weight: bold;
  border-radius: 50%;
  font-size: 13px;
}
.generalContainer {
  display: flex;
  flex-direction: column;
  padding: 5px;
  width: 100%;
  max-width: 100%;
  background: white;
  border-radius: 5px;
}

.rowProvisionService {
  height: 100%;
}

.ContentTable {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 1px;
  width: 100%;
  min-height: 60vh;
  max-width: 100%;
}
.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  background: #006256;
  color: whitesmoke;
  font-weight: bold;
}
.celTableMoreInfo {
  width: 33.3%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100px;
  border: 1px solid #f5f5f5;
  border-radius: 0 0 5px 5px;
}

.celTableMoreInfo span {
  color: #4e4e4e;
  font-weight: 600;
  font-size: 11px;
  background: #f3f3f3;
  border-bottom: 1px solid rgb(216, 216, 216);
  width: 100%;
  padding: 5px 0 0 5px;
  text-align: start;
  letter-spacing: 1px;
}

.rowTableMoreInfo {
  display: flex;
  text-align: start;
  font-size: 11px !important;
  padding: 2px 0 2px 10px;
  gap: 3px;
  background: whitesmoke;
  width: 100%;
  border-bottom: 1px solid #dedede;
}

.rowSupplier {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgb(207, 207, 207);
  border-radius: 2px 2px 5px 5px;
  text-align: center;
  padding: 0;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}
.rowSupplier.expanded {
  max-height: 200px;
  opacity: 1;
  transition: max-height 0.3s ease-in;
}
.lineTable {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  text-align: center;
  height: 35px;
  padding: 0;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}
.icon-chevron {
  transition: transform 0.3s ease;
}
.icon-rotated {
  transform: rotate(180deg);
}
.lineTableExpanded {
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.4s ease-in-out;
  border-top: 0px solid transparent;
  padding: 0;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
  gap: 3px;
}
.lineTableExpanded.show {
  max-height: 100px;
  background: whitesmoke;
  opacity: 1;
}
.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.celTableActions {
  display: flex;
  gap: 10px;
  width: 7%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #006256;
  border-radius: 5px;
  height: 25px;
  width: 30px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: white;
}

.btnActions {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #cecece;
  border-radius: 5px;
  color: white;
}

.btnActions1 {
  border-radius: 10px;
}

.contentActions {
  color: white;
}
.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 30px;
}
.btnGreenEst {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 30%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnWhiteEst {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 30%;
  height: 28px;
  position: relative;
  color: #006256;
  background: #eff0f0;
}
.closeEst {
  position: absolute;
  right: -10px;
  top: -10px;
  border: none;
  background: rgb(216, 216, 216);
  border-radius: 4px;
  color: rgb(255, 153, 0);
}
.rowEstorno {
  width: 100%;
  display: flex;
  align-items: center;
  background: #ebebeb;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 4px;
  text-align: center;
  height: 35px;
  gap: 1px;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
  padding: 10px;
  justify-content: space-between;
}
.celTableEst {
  display: flex;
  flex-direction: column;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #c3c3c3;
}
.number-control {
  display: flex;
  align-items: center;
  position: relative;
}

.number-left::before,
.number-right::after {
  content: attr(data-content);
  background-color: #006256;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  width: 20px;
  height: 30px;
  color: white;
  transition: background-color 0.3s;
  cursor: pointer;
}
.number-left {
  position: absolute;
  left: 0px;
  border-radius: 8px 0 0 8px;
  background-color: #006256;
}
.number-right {
  position: absolute;
  right: 0px;
  border-radius: 0 8px 8px 0;
  background-color: #006256;
}
.number-left::before {
  content: "-";
}

.number-right::after {
  content: "+";
}

.number-quantity {
  padding: 0.25rem;
  padding-left: 1.5rem;
  border: 0;
  width: 70px;
  text-align: center;
  border: 1px solid rgb(122, 122, 122);
}

.number-left:hover::before,
.number-right:hover::after {
  background-color: #006256;
}
.ctnDelAll {
  padding-top: 20px;
  display: flex;
  justify-content: space-around;
}

.ContentTableBill {
  display: flex;
  flex-direction: column;
  overflow: auto;
  font-size: 13px;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin-top: 10px;
  padding: 0 0 10px 0;
  background: #fbfbfb;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 10px;
}

.noContentTable {
  background: #edebeb;
  padding: 10px;
  height: 100%;
  text-align: center;
  letter-spacing: 0.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentStatus {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.contentStatus span {
  cursor: context-menu;
}

.statusPayment {
  background: #eff0f0;
  color: green;
}

.statusPaymentOpen {
  background: #eff0f0;
  color: rgb(132, 132, 132);
}

tr:nth-child(even) {
  background: #f2f3f3;
}

th {
  font-size: 12px;
  font-weight: normal;
}

td {
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.titleModal {
  font-size: 1rem;
  border-bottom: 1px solid #e6e7e8;
  font-weight: bold;
}

.titleModalBill {
  display: flex;
  justify-content: space-between;
  padding: 0px 0px 5px 0px;
  border-bottom: 1px solid #e6e7e8;
}

.textModalBill {
  font-weight: bold;
  width: 95%;
  text-align: center;
}

.closeModalBill {
  cursor: pointer;
}

.closeModalBill:hover {
  color: red;
}

.btnModal {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnModalCancel {
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.contentBtns {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.contentMotivo {
  font-size: 13px;
  margin-bottom: 20px;
  padding: 10px;
}

.contentMotivo label {
  position: relative;
  top: 10px;
}

.contentMotivo textarea:focus {
  box-shadow: none;
  border: 1px solid rgb(97, 95, 95);
}

.contentMotivo span {
  position: relative;
  top: 10px;
  color: red;
  cursor: context-menu;
}

.contentMotivo ::placeholder {
  font-size: 12px;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.contentModal {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  font-size: 13px;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowModal {
  display: flex;
  width: 100%;
  padding: 20px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.input-group-supplier {
  width: 45%;
  position: relative;
}

.user-label {
  position: absolute;
  left: 15px;
  font-size: 11px;
  z-index: 30;
  bottom: 21px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.closeModalDetails {
  width: 22px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -2px;
  top: -1px;
  color: red;
  border-radius: 2px;
  cursor: pointer;
  transition: ease-in all 0.2s;
  font-size: 18px;
}

.alertCancel {
  font-size: 10px;
  color: rgb(121, 3, 3);
  text-align: center;
  display: flex;
  margin-bottom: -10px;
  cursor: context-menu;
}

.delBill {
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  border: none;
  cursor: pointer;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 30vh;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.loadingLazy {
  position: absolute;
  top: 50%;
  width: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.loader {
  position: relative;
}

.loader span {
  position: absolute;
  color: #fff;
  transform: translate(-50%, -50%);
  font-size: 38px;
  letter-spacing: 5px;
}

.loader span:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 0.3px #006458;
}

.loader span:nth-child(2) {
  color: #006458;
  -webkit-text-stroke: 1px #006458;
  animation: loading 3s ease-in-out infinite;
}

@keyframes loading {
  0%,
  100% {
    clip-path: polygon(
      0% 30%,
      15% 54%,
      32% 50%,
      54% 60%,
      70% 61%,
      84% 69%,
      100% 32%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      16% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  bottom: 0;
  right: 0;
  position: absolute;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModalSales {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModalSales:hover {
  background: whitesmoke;
  color: red;
}

.closeModal:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnActions1:hover {
  background: rgb(215, 213, 213);
  color: white;
}

.btnActions1 {
  border-radius: 10px;
}

.contentActions {
  color: rgb(82, 78, 78);
}

.dropdown-submenu {
  position: relative;
}

.submenu {
  position: absolute;
  top: 0;
  right: 100%;
  background: white;
  border: 1px solid #ddd;
  min-width: 160px;
  z-index: 1000;
  border-radius: 0.25rem;
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.1);
}

.submenu .dropdown-item {
  white-space: nowrap;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: none !important;
}

.typeSale {
  color: #403b74;
  font-weight: bold;
}

.typeSale2 {
  color: #48b865;
  font-weight: bold;
}

.typeSale3 {
  color: #006256;
  font-weight: bold;
}

.typeSale4 {
  color: rgb(34, 33, 36);
  font-weight: bold;
}

.typeSale5 {
  color: #f2a83e;
  font-weight: bold;
}

.situationBall {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1px solid rgb(31, 30, 30);
}

.situationContent {
  display: flex;
  align-items: center;
  width: 90px;
  justify-content: flex-start;
  font-weight: bold;
}

.situationContent span {
  margin: 0 0 0 10px;

  font-weight: 600;
}

.situationContainer {
  display: flex;
  width: 100%;
  height: 30px;
  justify-content: center;
  align-items: center;
}

.summaryMonthText {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.month {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

@media screen and (min-width: 758px) and (max-width: 1200px) {
  .GeneralSales {
    margin-left: 60px;
    width: calc(100% - 60px);
    font-size: 11px;
  }

  .searchByMonth {
    width: 40%;
    margin: 10px 0px 0px 10px;
  }

  .form-control {
    width: 140px;
  }

  .ItemSummarySales {
    height: 60px;
    font-size: 11px;
  }

  .SummarySales {
    height: 100px;
    padding-bottom: 10px;
  }

  .BtnSales {
    height: 30px;
    font-size: 11px;
  }

  .searchAll {
    font-size: 11px;
    padding: 5px 9px;
  }

  .searchInputAll {
    width: 18%;
  }

  .searchInputDate {
    width: 45%;
  }

  .btnPeriod {
    width: 60px;
    font-size: 10px;
  }

  .searchFilter {
    width: 110px;
    font-size: 10px;
  }

  .searchContainer {
    height: 70px;
  }

  .setBtn {
    margin: 0 1rem 10px 0;
  }

  .itemBtn {
    width: 18px;
    height: 18px;
  }

  .centerItemBtn {
    width: 18px;
    height: 18px;
  }

  .headTable {
    height: 25px;
  }

  .ContentTable {
    padding: 0px 20px 0 20px;
  }
}

@media screen and (max-width: 700px) {
  .GeneralSales {
    display: flex;
    flex-direction: column;
    margin: auto;
    width: 100%;
    height: 100vh;
    font-size: 10px;
  }

  .ContainerBtnSales {
    margin-top: 55px;
    flex-wrap: wrap;
  }

  .lineSearch {
    display: flex;
    align-items: center;
    margin-left: 0px;
    justify-content: center;
  }

  .searchContainer {
    display: none;
  }

  .BtnSales {
    height: 70px;
  }

  .searchByMonth {
    width: 80%;
    margin: 20px 0px 0px 0px;
  }

  .ItemSummarySales {
    height: 100px;
  }

  .ContentTable {
    height: auto;
    padding: 10px 10px 0 10px;
  }

  .ModalGeneral {
    position: fixed !important;
    z-index: 900;
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }
}
.contentNewAlertIcon {
  width: 25px;
  min-width: 25px;
  height: 25px;
  min-height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 0 0 / 12%);
  border-radius: 8px;
}

.contentReportError {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 8px;
  background-color: white;
  box-shadow: rgb(222, 222, 222) 0px 0px 3px 1px;
  padding: 0.5rem 0.5rem;
  gap: 0.5rem;
}

.selectProductsFiscalModal {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.selectProductsFiscalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  font-size: 0.82rem;
}

.selectProductsFiscalList {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  max-height: 360px;
  overflow: auto;
}

.selectProductsFiscalItem {
  display: flex;
  gap: 0.7rem;
  align-items: flex-start;
  padding: 0.65rem;
  border: 1px solid #d8e5df;
  border-radius: 6px;
  cursor: pointer;
  margin: 0;
}

.selectProductsFiscalInfo {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.78rem;
}

.selectProductsFiscalInfo span {
  font-family: Poppins-Regular, sans-serif !important;
  color: #5f6368;
  font-size: 0.72rem;
}

.selectProductsFiscalActions {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
}
</style>
